import { mergeMap } from 'rxjs/operators';
import { Observable, timer, throwError } from 'rxjs';

export const genericRetryStrategy = (
  {
    maxRetryAttempts = 5,
    scalingDuration = 1000,
    statusCodes: statusCodes = [0, 503, 504]
  }: {
    maxRetryAttempts?: number;
    scalingDuration?: number;
    statusCodes?: number[];
  } = {}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => (attempts: Observable<any>) => attempts.pipe(
    mergeMap((error, i) => {
      const retryAttempt = i + 1;

      if (retryAttempt > maxRetryAttempts || statusCodes.every(status => status !== error.status)) {
        return throwError(error);
      }

      console.log(`Attempt ${retryAttempt}: retrying in ${retryAttempt * scalingDuration}ms`);
      return timer(retryAttempt * scalingDuration);
    })
  );
